import { render, staticRenderFns } from "./floors.vue?vue&type=template&id=61644f00&scoped=true"
import script from "./floors.vue?vue&type=script&lang=js"
export * from "./floors.vue?vue&type=script&lang=js"
import style0 from "./floors.vue?vue&type=style&index=0&id=61644f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61644f00",
  null
  
)

export default component.exports